import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {Button , Col, Row ,Calendar} from 'vant';
import 'vant/lib/index.css';




createApp(App)
.use(store)
.use(router)
.use(Button)
.use(Col)
.use(Row)
.use(Calendar)

.mount('#app')
